import React, { ReactNode } from "react"
import clsx from "clsx"
import { Box, Row } from "ui/components/atoms/_atoms"
import Switch from "ui/components/atoms/switch"
import { Label, P } from "ui/components/atoms/typography"
import { BaseStyles } from "ui/types/base-styles"
import { generateStylesFromProps } from "ui/utils/styles"

import styles from "./SwitchRow.module.css"

const SwitchRow = ({
  value,
  name,
  title,
  text,
  icon,
  onChange,
  disabled = false,
  $showBorder = true,
  $withBackground = false,
  ...rest
}: {
  value: boolean
  name: string
  icon?: string
  title: string
  text?: string
  onChange: (e: { name: string; value: boolean }) => void
  disabled?: boolean
  $showBorder?: boolean
  $withBackground?: boolean
} & BaseStyles) => {
  const generatedStyles = generateStylesFromProps(rest)

  return (
    <div
      className={clsx(styles.wrapper, {
        [styles.disabled]: disabled,
        [styles.showBorder]: $showBorder,
        [styles.withBackground]: $withBackground,
      })}
      style={generatedStyles}
    >
      <div className={styles.content}>
        <Label icon={icon} $iconSize="M" $fontSize="M" $marginBottom="XXS">
          {title}
        </Label>
        {text && (
          <P $small $marginBottom="0" $fontSize="S">
            {text}
          </P>
        )}
      </div>
      <Box $marginTop="2px">
        <Switch name={name} value={value} onChange={onChange} />
      </Box>
    </div>
  )
}

export default SwitchRow
